module.exports = __webpack_public_path__ + "img/absa-logo.6b4279fc.png";